export const environment = {
  production: true,
  baseUrl: 'https://api.bookapen.com/api/',
  // baseUrl: 'http://demobookapen-env.eba-xtdpdapp.eu-west-1.elasticbeanstalk.com/api/',
  cognitoUrl: 'https://bookapen.auth.eu-west-1.amazoncognito.com/login?response_type=token&client_id=3cifk5oh9jp97i8rfsfldb9qfk&redirect_uri=https://bookapen.com/code'

};
